export enum Picto {
    Romanee = 'romanee',
    Camping_1R = 'camping-1R',
    Camping_2R = 'camping-2R',
    Camping_3R = 'camping-3R',
};